import type { QueryClient } from '@tanstack/react-query'
import { clearDraft } from '~/lib/draft'

/** Every query under `['member', ...]` belongs to a person (their session or their registration), never to the page. */
const PRIVATE = ['member'] as const

/**
 * The one place that forgets the previous person: cancels the private queries still in flight (so a late answer
 * cannot land in the next session's cache) and removes what they cached. Call it before a new identity is installed
 * (login), when the session ends (logout) and after an erasure.
 */
export function dropPrivateSession(qc: QueryClient): void {
  void qc.cancelQueries({ queryKey: PRIVATE })
  qc.removeQueries({ queryKey: PRIVATE })
}

/** After an erasure: the private cache and the browser draft (name, email, place) are both gone. */
export function forgetErasedPerson(qc: QueryClient): void {
  dropPrivateSession(qc)
  clearDraft()
}
